import styled from "styled-components";

const Wrapper = styled.div`
  .admin-section-row {
    margin-top: 16px;
  }

  .seat-summary {
    margin-top: 12px;
  }
`;

export default Wrapper;
